import React, { useState } from "react";
import "../Career/Careers.css";
import Header from '../Header/header';
import Footer from "../Footer/footer";

const jobs = [
    {
        id: 1,
        jobTitle: "Salesforce Developer",
        category: "IT",
        subcategory: "Software Development",
        details: {
            jobRole: "Salesforce Development",
            MandatorySkills: "Apex: 3+ years, Salesforce: 3+ years, Lightning Components (Aura), LWC: 3 years, VF Pages: 3 years, Salesforce APIs (SOAP, REST, Bulk API), Integration Patterns, PD1 (Platform Developer I)",
            Experience: "3+ years experience mandatory",
            Salary: "",
            ExtraBenefits: [],
            ShiftTimeAndWeekOff: "",
            Communication: "",
            TransportFacility: "",
            ImmediateJoiner: ""
        }
    },
    {
        id: 2,
        jobTitle: "Customer Service",
        category: "Non IT",
        subcategory: "BPO",
        details: {
            jobRole: "Customer Service",
            Experience: "Open to both freshers and experienced candidates",
            Salary: "₹28,500 CTC to ₹40,000",
            ExtraBenefits: [],
            ShiftTimeAndWeekOff: "Rotational Shift (Day shift for females until 9 PM; Rotational for males)",
            Communication: "Excellent communication skills in both English and Hindi. No Mother Tongue Influence (MTI) or Regional Tongue Influence (RTI), and no grammatical or pronunciation errors.",
            TransportFacility: "",
            ImmediateJoiner: "",
            Other: {
                Position: "L1",
                Location: "Kharadi, Pune",
                Education: "Graduate in any field",
                WritingSkills: "Strong Hindi writing skills",
                Certification: "Veti 6 certified",
                Preferred: "Insurance experience and sales acumen"
            }
        }
    },
    {
        id: 3,
        jobTitle: "Customer Service Associate (Voice)",
        category: "Non IT",
        subcategory: "BPO",
        details: {
            jobRole: "Customer Care, Non-Voice",
            Qualification: ["HSC", "Graduate"],
            Salary: {
                CTC: "15K",
                InHand: "12.6K"
            },
            ExtraBenefits: ["Incentives", "Over Time (we pay the highest over time)"],
            ShiftTimeAndWeekOff: "6 Days working 24*7 Rotational Shifts (Including Night Shifts). 1 Rotational Week Off.",
            Communication: "Fluent English Communication",
            TransportFacility: "Pick-up or Drop facility available (One side transport available)",
            ImmediateJoiner: "Preferred"
        }
    },
    {
        id: 4,
        jobTitle: "Customer Service Associate (Voice)",
        category: "Non IT",
        subcategory: "BPO",
        details: {
            jobRole: ["Ticket booking, cancellation, Flight delays", "Solving queries related to Refund and baggage's", "Informing customers related to the flights"],
            Qualification: ["HSC", "Graduate"],
            Salary: {
                CTC: "15K",
                InHand: "12.6K"
            },
            ExtraBenefits: ["Incentives", "Over Time (we pay the highest over time)"],
            ShiftTimeAndWeekOff: "6 Days working 24*7 Rotational Shifts (Including Night Shifts). 1 Rotational Week Off.",
            Communication: "Fluent English Communication",
            TransportFacility: "Pick-up or Drop facility available (One side transport available)",
            ImmediateJoiner: ""
        }
    }
];

const Career = () => {
    const [selectedJob, setSelectedJob] = useState(null);

    const handleJobClick = (job) => {
        setSelectedJob(job);
    };

    const handleCloseModal = () => {
        setSelectedJob(null);
    };

    const renderDetail = (label, detail) => {
        if (Array.isArray(detail) && detail.length > 0) {
            return (
                <li>{label}: {detail.join(', ')}</li>
            );
        } else if (typeof detail === 'object' && detail !== null && Object.keys(detail).length > 0) {
            return (
                <>
                    <li>{label}:</li>
                    <ul>
                        {Object.entries(detail).map(([key, value]) => (
                            <li key={key}>{`${key}: ${value || 'Not mentioned'}`}</li>
                        ))}
                    </ul>
                </>
            );
        } else if (detail && detail !== "") {
            return <li>{label}: {detail}</li>;
        }
        return <li>{label}: Not mentioned</li>;
    };

    return (
        <>
            <Header/>
            <div className="career-container">
                <h1 className="career-title">Career Opportunities</h1>
                <div className="job-list">
                    {jobs.map((job) => (
                        <div 
                            key={job.id} 
                            className="job-card" 
                            onClick={() => handleJobClick(job)}
                        >
                            <div className="job-title">{job.jobTitle}</div>
                            <div className="job-summary">
                                {job.details.jobRole}
                            </div>
                            <ul className="job-qualifications">
                                {renderDetail('Mandatory Skills', job.details.MandatorySkills)}
                                {renderDetail('Experience', job.details.Experience)}
                                {renderDetail('Salary', job.details.Salary)}
                                {renderDetail('Shift Time & Week Off', job.details.ShiftTimeAndWeekOff)}
                                {renderDetail('Communication', job.details.Communication)}
                                {renderDetail('Transport Facility', job.details.TransportFacility)}
                                {renderDetail('Immediate Joiner', job.details.ImmediateJoiner)}
                                {renderDetail('Extra Benefits', job.details.ExtraBenefits)}
                                {job.details.Other && Object.entries(job.details.Other).map(([key, value]) => (
                                    renderDetail(key, value)
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>

                {selectedJob && (
                    <div className="modal">
                        <div className="modal-content">
                            <span className="close" onClick={handleCloseModal}>
                                &times;
                            </span>
                            <h2 className="modal-job-title">{selectedJob.jobTitle}</h2>
                            <p className="modal-job-summary">{selectedJob.details.jobRole}</p>
                            <h3>Key Qualifications</h3>
                            <ul className="modal-job-qualifications">
                                {renderDetail('Mandatory Skills', selectedJob.details.MandatorySkills)}
                                {renderDetail('Experience', selectedJob.details.Experience)}
                                {renderDetail('Salary', selectedJob.details.Salary)}
                                {renderDetail('Shift Time & Week Off', selectedJob.details.ShiftTimeAndWeekOff)}
                                {renderDetail('Communication', selectedJob.details.Communication)}
                                {renderDetail('Transport Facility', selectedJob.details.TransportFacility)}
                                {renderDetail('Immediate Joiner', selectedJob.details.ImmediateJoiner)}
                                {renderDetail('Extra Benefits', selectedJob.details.ExtraBenefits)}
                                {selectedJob.details.Other && Object.entries(selectedJob.details.Other).map(([key, value]) => (
                                    renderDetail(key, value)
                                ))}
                            </ul>
                        </div>
                    </div>
                )}
            </div>
            <Footer/>
        </>
    );
};

export default Career;
